import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { hasSpouseDetails, isPersonTravellingWith } from '../../../../../utilities/pages';
import { useTranslation } from "react-i18next";

function VisaPrepFamilyStep1(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.MARITAL_STATUS}
        label={t('forms.visa:whatIsYourMaritalStatus')}
        value={String(props.maritalStatus).toLowerCase()}
      />
      {props.maritalStatus !== undefined && hasSpouseDetails(props.maritalStatus) ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_NATIONALITY}
            value={props.spouseNationality}
            label={t('forms.visa:spouseNationality')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_SAME_NATIONALITY}
            label={t('forms.visa:spouseHaveTheyAlwaysHadTheSameNa')}
            value={boolToYesNo(props.spouseSameNationality)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_FAMILY_NAME}
            value={props.spouseFamilyName}
            label={t('forms.visa:spouseFamilyName')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_GIVEN_NAME}
            value={props.spouseGivenName}
            label={t('forms.visa:spouseGivenName')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_DOB}
            label={t('forms.visa:spouseDateOfBirth')}
            value={props.spouseDob}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_LIVING_WITH}
            label={t('forms.visa:doesYourSpousePartnerCurrentlyLi')}
            value={boolToYesNo(props.spouseLivingWith)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.SPOUSE_TRAVELLING_WITH}
            label={t('forms.visa:spouseIsThisPersonTravellingWith')}
            value={props.spouseTravellingWith}
          />
          {isPersonTravellingWith(props.spouseTravellingWith) ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.SPOUSE_UK_VISA}
                label={t('forms.visa:spouseDoTheyHaveAVisaForTheUk')}
                value={boolToYesNo(props.spouseUkVisa)}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.SPOUSE_HAS_PASSPORT}
                label={t('forms.visa:spouseDoTheyHaveAPassportOrTrave')}
                value={boolToYesNo(props.spouseHasPassport)}
              />
              {props.spouseHasPassport ? (
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.SPOUSE_PASSPORT_NUMBER}
                  value={props.spousePassportNumber}
                  label={t('forms.visa:spouseCurrentPassportOrTravelDoc')}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep1;
